"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpensePaymentOptionEnum = void 0;
var ExpensePaymentOptionEnum;
(function (ExpensePaymentOptionEnum) {
    ExpensePaymentOptionEnum[ExpensePaymentOptionEnum["BANK_TRANSFER"] = 0] = "BANK_TRANSFER";
    ExpensePaymentOptionEnum[ExpensePaymentOptionEnum["SMART_CARD"] = 1] = "SMART_CARD";
})(ExpensePaymentOptionEnum || (exports.ExpensePaymentOptionEnum = ExpensePaymentOptionEnum = {}));
